var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWhy(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 194,
    height: 202,
    viewBox: "0 0 194 202",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_98_4166)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.1847 8.70215H50.9517V10.3613H49.1847V8.70215Z",
    fill: "#72E9AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.0777 26.0485H37.8447V27.7076H36.0777V26.0485Z",
    fill: "#72E9AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.5944 65.6935H43.3613V67.3527H41.5944V65.6935Z",
    fill: "#72E9AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.29 116.654H136.057V118.313H134.29V116.654Z",
    fill: "#72E9AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.378 57.7629H179.145V59.422H177.378V57.7629Z",
    fill: "#72E9AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.156 43.4777H185.923V45.1369H184.156V43.4777Z",
    fill: "#72E9AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.947 148.41H143.714V150.069H141.947V148.41Z",
    fill: "#72E9AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.5944 192.136H43.3613V193.796H41.5944V192.136Z",
    fill: "#72E9AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.5875 0H72.3545V1.65914H70.5875V0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.3258 8.70215H62.0928V10.3613H60.3258V8.70215Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.9752 200.341H56.7422V202H54.9752V200.341Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.854 55.241H193.621V56.9001H191.854V55.241Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.345 135.668H155.112V137.327H153.345V135.668Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.2758 33.7303H139.085V35.3894H84.2758V33.7303Z",
    fill: "#72E9AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.2758 46.0743H139.085V47.7334H84.2758V46.0743Z",
    fill: "#72E9AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.0664 134.838H98.876V136.497H44.0664V134.838Z",
    fill: "#72E9AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.0666 147.19H53.084V148.85H44.0666V147.19Z",
    fill: "#72E9AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.0929 147.19H98.876V148.85H62.0929V147.19Z",
    fill: "#72E9AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.519 159.534H98.3286V161.194H43.519V159.534Z",
    fill: "#72E9AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.2758 58.5925H117.566V60.2516H84.2758V58.5925Z",
    fill: "#72E9AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.052 58.5925H139.085V60.2516H128.052V58.5925Z",
    fill: "#72E9AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5167 164.752C15.7203 163.118 12.4518 155.917 12.5763 147.779C12.5763 145.075 12.8583 142.437 13.3893 139.89H15.0899C14.5341 142.437 14.2271 145.083 14.2271 147.796C14.1027 156.44 18.1095 164.246 18.151 164.321L18.3252 164.644L15.5047 172.194H13.7377L16.5167 164.744V164.752Z",
    fill: "#72E9AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.824 151.073C126.924 149.986 126.982 148.891 126.982 147.779C126.982 127.488 110.474 110.971 90.174 110.971H51.035C34.0454 110.971 19.7104 122.544 15.4962 138.231H13.7707C18.0264 121.623 33.1163 109.312 51.035 109.312H90.174C111.386 109.312 128.641 126.567 128.641 147.779C128.641 148.891 128.583 149.986 128.492 151.073H126.824Z",
    fill: "#72E9AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8905 173.853L9.46507 188.403L31.0587 179.112L31.4818 178.93L31.8634 179.195C31.9381 179.245 39.7775 184.587 50.9684 184.587H90.1904C108.806 184.587 124.228 170.692 126.65 152.732H128.326C125.887 171.613 109.718 186.246 90.1904 186.246H50.9684C40.549 186.246 33.0829 181.941 31.3159 180.821L6.56988 191.473L13.1401 173.861H14.907L14.8905 173.853Z",
    fill: "#72E9AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.687 24.3893C153.993 15.1977 143.15 9.2082 130.931 9.2082H91.7916C71.5004 9.2082 54.9836 25.7166 54.9836 46.0162C54.9836 49.5004 55.4814 52.8767 56.3939 56.0705H54.6684C53.7974 52.8601 53.3245 49.4921 53.3245 46.0079C53.3245 24.7958 70.5795 7.54077 91.7916 7.54077H130.931C144.137 7.54077 155.801 14.2271 162.728 24.381H160.687V24.3893Z",
    fill: "#72E9AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.8192 70.082C58.8908 66.4484 56.6095 62.2674 55.1578 57.7297H56.9082C58.4512 62.3172 60.8735 66.4982 63.9844 70.082H61.8192Z",
    fill: "#72E9AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.5025 71.7411C72.1889 78.5685 81.4966 82.8159 91.7833 82.8159H130.922C137.725 82.8159 144.378 80.941 150.152 77.3988L150.517 77.1748L172.5 86.6402L163.765 63.2214L163.591 62.7569L163.914 62.3836C163.956 62.3338 168.377 57.0743 167.73 46.0079C167.73 38.6496 165.557 31.7974 161.824 26.0402H163.798C167.34 31.8554 169.389 38.6745 169.389 45.9581C169.987 56.0871 166.569 61.5955 165.482 63.0721L175.412 89.693L150.649 79.033C144.701 82.5919 137.891 84.475 130.922 84.475H91.7833C80.4597 84.475 70.2643 79.5556 63.2212 71.7411H65.5025Z",
    fill: "#72E9AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.348 43.4777C168.452 23.9745 152.309 8.37862 132.582 8.37862H93.4426C79.1741 8.37862 66.7886 16.5416 60.683 28.4459H58.8164C65.0548 15.5959 78.2283 6.71948 93.4426 6.71948H132.582C153.238 6.71948 170.128 23.0786 171.007 43.4777H169.348Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.39 45.1368H171.049C171.646 55.2659 168.228 60.7742 167.141 62.2508L168.734 66.5231H166.967L165.424 62.3919L165.25 61.9273L165.573 61.554C165.615 61.5042 170.037 56.2448 169.39 45.1783C169.39 45.1617 169.39 45.1451 169.39 45.1285V45.1368Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.8864 30.105C57.8042 34.7091 56.6428 39.811 56.6428 45.1866C56.6428 65.4779 73.1512 81.9946 93.4508 81.9946H132.59C139.392 81.9946 146.045 80.1197 151.819 76.5775L152.184 76.3535L174.168 85.8189L167.589 68.1905H169.356L177.071 88.88L152.309 78.22C146.361 81.7789 139.55 83.662 132.582 83.662H93.4425C72.2304 83.662 54.9753 66.407 54.9753 45.1949C54.9753 39.8442 56.0787 34.7506 58.0613 30.1133H59.8781L59.8864 30.105Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.641 146.95C128.641 143.018 128.011 139.227 126.866 135.668H128.608C129.703 139.235 130.3 143.026 130.3 146.95C130.3 152.607 129.064 157.975 126.858 162.819H125.033C127.339 158.016 128.633 152.632 128.633 146.95H128.641Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.285 134.009C121.034 120.08 107.578 110.142 91.8333 110.142H52.6942C39.3796 110.142 27.691 117.251 21.2287 127.87H19.3124C25.9489 116.297 38.4256 108.483 52.6942 108.483H91.8333C108.508 108.483 122.726 119.143 128.052 134.009H126.285Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1756 163.914C17.3792 162.28 14.1107 155.08 14.2352 146.942C14.2352 140.678 15.7533 134.755 18.4245 129.521H20.291C17.4871 134.714 15.8943 140.645 15.8943 146.95C15.7699 155.594 19.7767 163.4 19.8182 163.475L19.9924 163.798L11.1326 187.557L32.7263 178.266L33.1493 178.084L33.531 178.349C33.6056 178.399 41.445 183.741 52.6359 183.741H91.8579C105.811 183.741 117.981 175.935 124.219 164.462H126.086C119.698 176.881 106.765 185.4 91.8662 185.4H52.6442C42.2248 185.4 34.7587 181.095 32.9917 179.975L8.24569 190.627L18.2088 163.906L18.1756 163.914Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.7389 45.8503H54.9834V47.5094H31.7389V45.8503Z",
    fill: "#72E9AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.823 123.929H120.104V125.588H106.823V123.929Z",
    fill: "#72E9AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.8546 37.5463H63.9761V39.2054H55.8546V37.5463Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.947 169.439H150.069V171.099H141.947V169.439Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.26 175.213H123.381V176.872H115.26V175.213Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.090929 160.364H8.2124V162.023H0.090929V160.364Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.202 19.7355H185.923V21.3946H161.202V19.7355Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.41019 119.591H26.1313V121.25H1.41019V119.591Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.9133 80.3521H78.0205V82.0112H64.9133V80.3521Z",
    fill: "#72E9AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.9573 87.6771H50.0645V89.3363H36.9573V87.6771Z",
    fill: "#72E9AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-0.00855637 151.902H13.0986V153.561H-0.00855637V151.902Z",
    fill: "#72E9AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.202 38.3759H169.323V40.035H161.202V38.3759Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.94 130.193H126.061V131.852H117.94V130.193Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.46 73.8482H186.056V75.5073H170.46V73.8482Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.3514 22.7302H62.9473V24.3893H47.3514V22.7302Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_98_4166"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 193.621,
    height: 202,
    fill: "white",
    transform: "matrix(-1 0 0 1 193.621 0)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhy);
export default __webpack_public_path__ + "static/media/why.52db03bccb8811565c886896f1614536.svg";
export { ForwardRef as ReactComponent };